// extracted by mini-css-extract-plugin
export default {"player":"VmPUb","time":"CX0M7","controls":"bTWEf","progress":"_6zTuh","seek":"BVfpK"};